<template>
	<c-dialog ref="dialog" height="250" width="600" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="C端质检模板" required tip="请选择C端质检模板">
        <c-select name="c_template_id" v-model="c_template_id" async @search="searchTemplate" :value-data="selectedCTemplate"></c-select>
      </c-form-item>
      <c-form-item label="B端质检模板" required tip="请选择B端质检模板">
        <c-select name="b_template_id" v-model="b_template_id" async @search="searchTemplate" :value-data="selectedBTemplate"></c-select>
      </c-form-item>
    </c-form>
	</c-dialog>
</template>

<script>
export default {
	computed: {
	},
	
	data() {
		return {
			  editState: false,
        ids:[],
        modelId:0,
        c_template_id:0,
        b_template_id:0,
        selectedCTemplate:[], //已选中的C端质检模板
        selectedBTemplate:[] //已选中的B端质检模板
    }
	},
  watch: {
  },

	methods: {
    /*******搜索质检模板*****************/
    searchTemplate(keyword, resolve){
      this.request({
        url:'/spu/template/options',
        data: {
          keyword: keyword
        },
        success:data => {
          resolve(data);
        }
      })
    },
		/*********打开编辑框，初始化**********/
		open(ids,data) {
      var title = "批量配置型号关联质检模板配置";
			this.$refs.form.clear();
      this.ids = [];
      if (data) {
          this.modelId = data.id;
          //已选中的[C端质检模板]
          if (data.c_template_id){
              this.selectedCTemplate = [{
                name: data.c_template_name,
                value:data.c_template_id
              }];
          }
          if (data.b_template_id){
            //已选中的[B端质检模板]
            this.selectedBTemplate = [{
              name: data.b_template_name,
              value:data.b_template_id
            }];
          }
          title = '型号【'+data.model_name+'】关联质检模板配置';
          this.ids.push(data.id);
      }else {
          this.ids = ids;
          this.selectedCTemplate = [];
          this.selectedBTemplate = [];
      }
			//设置标题
			this.$refs.dialog.open({
				title:title
			});
		},

		/*******添加、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: '/spu/model/edit/template',
				rule: {
          c_template_id: '请选择C端质检模板',
          b_template_id: '请选择B端质检模板'
				},
				dataFormatter: data => {
          data.model_ids = this.ids;
					return data;
				},
				success: (data, res) => {
					next();
          this.$message({
            message: '配置质检模板成功',  // 提示内容,
            type: 'success'
          });
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>